/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-deprecated */
import moment from 'moment'
import React, { Component } from 'react'
import { DatePicker, Button, message } from 'antd'
import classNames from 'classnames'
import './index.less'

function getCalendarContainer(trigger) {
  return trigger.parentNode
}
const defaultConfig = {
  open: true,
  showToday: false,
  dropdownClassName: 'mn-daterange-item-content',
  laterDate: '',
  getCalendarContainer
}

class DateRange extends Component {
  static defaultProps = {
    format: 'YYYY-MM-DD',
    ranges: [],
    value: [],
    tipDates: [],
    checkAuth: true,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange() { },
  }

  state = {
    value: this.stringValToMoment(this.props.value)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        value: this.stringValToMoment(nextProps.value)
      })
    }
  }

  onChange(index, value) {
    this.state.value[index] = value
    this.setState({
      value: this.state.value
    })
  }

  onRangesClick(value) {
    this.setState({
      value: [...value]
    })
  }

  onClick() {
    const [startDate, endDate] = this.state.value
    if (!moment.isMoment(startDate) || !moment.isMoment(endDate)) {
      return
    }
    if (endDate.isBefore(startDate.startOf('d'))) {
      message.error('结束时间不能小于开始时间')
      return
    }
    this.props.onChange([
      startDate.format(this.props.format),
      endDate.format(this.props.format)
    ])
  }

  getStrValue(index) {
    const { value } = this.state
    if (value[index]) {
      return value[index].format(this.props.format)
    }
    return ''
  }

  dateRender(current) {
    const style = {}
    let p = null
    if (this.props.tipDates.includes(current.format('YYYY-MM-DD'))) {
      style.position = 'relative'
      p = <div style={{ width: 3, height: 3, backgroundColor: '#f55', borderRadius: '50%', position: 'absolute', top: 0, right: 0 }} />
    }
    return (
      <div className="ant-calendar-date" style={style}>
        {p}
        {current.date()}
      </div>
    )
  }

  isSame(value) {
    const vals = this.state.value
    return value[0]?.isSame(vals[0], 'day') && value[1]?.isSame(vals[1], 'day')
  }

  submitDisabled() {
    const [startDate, endDate] = this.state.value
    return moment.isMoment(startDate) && moment.isMoment(endDate)
  }

  stringValToMoment(strArray) {
    if (!strArray) {
      return []
    }
    const moments = []
    if (strArray[0]) {
      moments[0] = moment(strArray[0])
    }
    if (strArray[1]) {
      moments[1] = moment(strArray[1])
    }
    return moments
  }

  disabledDate(currentDate) {
    let before = moment(this.props.earlistDate)
    const begin = this.props.laterDate ? moment(this.props.laterDate) : moment().subtract(1, 'day').endOf('day')
    if (!this.props.checkAuth) {
      if (!this.props.laterDate) {
        return moment.isMoment(currentDate) && currentDate.isBefore(before)
      }
      return (currentDate.isBefore(before)
        || currentDate.isAfter(moment().subtract(0, 'day').endOf('day')))
    }
    if (this.props.accountInfo?.userAuthCodeList?.some(m => m === 'history_no_limit')) {
      before = this.props.earlistDate
    } else if (this.props.accountInfo?.userAuthCodeList?.some(m => m === 'history_two_year')) {
      before = moment.max(before, moment(begin).subtract(2, 'year').subtract(1, 'quarter').startOf('quarter'))
    } else if (this.props.accountInfo?.userAuthCodeList?.some(m => m === 'history_one_year')) {
      before = moment.max(before, moment(begin).subtract(1, 'year').subtract(1, 'quarter').startOf('quarter'))
    } else if (this.props.accountInfo?.userAuthCodeList?.some(m => m === 'history_six_month')) {
      before = moment.max(before, moment(begin).subtract(6, 'month').subtract(1, 'quarter').startOf('quarter'))
    }
    return moment.isMoment(currentDate) && (currentDate.isBefore(before)
      || currentDate.isAfter(begin))
  }

  render() {
    const { ranges, dateRender, buttonClassName, rangeLeftConfig, overlayProps } = this.props
    const { value } = this.state
    return (
      <div className="mn-daterange" {...overlayProps}>
        {
          !rangeLeftConfig?.disabled && <div className="mn-daterange-item">
            <div className="mn-daterange-title"><span className="mn-daterange-label">开始时间:</span>{this.getStrValue(0)}</div>
            <div className="mn-daterange-pick-wrap">
              <DatePicker
                getPopupContainer={triggerNode => triggerNode}
                dateRender={dateRender || this.dateRender.bind(this)}
                {...defaultConfig}
                disabledDate={this.disabledDate.bind(this)}
                value={value[0]}
                onChange={this.onChange.bind(this, 0)}
              />
            </div>
          </div>
        }
        <div className="mn-daterange-item">
          <div className="mn-daterange-title"><span className="mn-daterange-label">结束时间:</span>{this.getStrValue(1)}</div>
          <div className="mn-daterange-pick-wrap" style={{ left: 10 }}>
            <DatePicker
              getPopupContainer={triggerNode => triggerNode}
              dateRender={dateRender || this.dateRender.bind(this)}
              {...defaultConfig}
              disabledDate={this.disabledDate.bind(this)}
              value={value[1]}
              onChange={this.onChange.bind(this, 1)}
            />
          </div>
        </div>
        <div className="mn-daterange-right">
          <ul>
            {ranges.map(m => (
              <li
                onClick={this.onRangesClick.bind(this, m.value)}
                className={`daterage-ranges ${this.isSame(m.value) ? 'active' : ''}`}
              >{m.name}
              </li>
            ))}
          </ul>
          <Button type="primary" disabled={!this.submitDisabled()} size="small" onClick={this.onClick.bind(this)} className={classNames(buttonClassName, { disabled: !this.submitDisabled() })}>确定</Button>
        </div>
      </div>
    )
  }
}

export default DateRange
